import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import NetflixUI from './components/NetflixUI';
import './App.css';
import Login from './components/Login';

function AppContent() {
  const { currentUser } = useAuth();
  
  return currentUser ? <NetflixUI /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
